'use strict';

exports.__esModule = true;
exports.loaders = exports.dynamicArgumentsMap = undefined;

var _pageActions = require('../actions/page-actions');

var _pageActions2 = _interopRequireDefault(_pageActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 Here we specify where to find the arguments to replace in the loaders int the request.
 **/
var dynamicArgumentsMap = exports.dynamicArgumentsMap = {
    _errorMessage_: 'query.errorMessage',
    _errorCode_: 'query.errorCode'
};

/**
 Loaders.
 **/
var loaders = exports.loaders = [{
    key: 'loadedUri',
    action: _pageActions2.default.loadUri,
    arguments: ['_errorMessage_', '_errorCode_'],
    dynamicArguments: ['_errorMessage_', '_errorCode_']
}];


// WEBPACK FOOTER //
// ./components/error-page/lib/utils/loaders.js